import React, { FC } from 'react';

import Title from 'antd/es/typography/Title';
import { TitleProps } from 'antd/lib/typography/Title';
import { clsx } from 'clsx';

// or use 'classnames' if you prefer

interface CardTitleProps extends Partial<TitleProps> {
  className?: string;
}

export const CardTitle: FC<CardTitleProps> = ({
  children,
  className,
  ...props
}) => {
  return (
    <Title
      {...props}
      className={clsx('text-2xl sm:text-4xl text-blue font-bold', className)}
    >
      {children}
    </Title>
  );
};
